<template>
    <div id="shortlistPage">
        <div class="contentBox">
            <div class="clearfix contentBox-top">
                <div class="title">我的征稿</div>
            </div>
            <div class="contentFormBox">
            
              <el-table
                :data="myShenBaoData"
                v-loading="tableLoading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-customClass="loadingStyles"
                style="width: 100%"
                class="maintable"
                border
                :header-cell-style="{ background: '#f8f8f8' }"
                @selection-change="handleTableSelectionChange"
              >
                <el-table-column
                  type="selection"
                  min-width="55"
                  align="center"
                ></el-table-column>
                <el-table-column type="index" min-width="50" align="center">
                </el-table-column>
                <el-table-column
                  prop="name"
                  min-width="80"
                  label="成果名称"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="applyName"
                  min-width="80"
                  label="申请人"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="workUnit"
                  show-overflow-tooltip
                  label="所在单位"
                  min-width="70px"
                  align="center"
                >
                </el-table-column
                >
                <el-table-column
                  prop="sourceInfo.name"
                  show-overflow-tooltip
                  label="申报时间"
                  min-width="70px"
                  align="center"
                >
                </el-table-column
                >
                <el-table-column
                  prop="status"
                  show-overflow-tooltip
                  label="审核状态"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.status == 10"
                      >待审核</span>
                    <span effect="dark" v-if="scope.row.status == 20"
                      >审核通过</span>
                    <span effect="dark" v-if="scope.row.status == 30"
                      >审核不通过</span>
                    <span effect="dark" v-if="scope.row.status == 40"
                    >入选</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  prop="addUser"
                  show-overflow-tooltip
                  label="审核意见"
                  min-width="70px"
                  align="center"
                >
                </el-table-column> -->
                <el-table-column
                  show-overflow-tooltip
                  label="操作"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      class="right-add-button"
                      @click="preview(scope.row)"
                      >【预览】</span
                    >
                    <span
                      class="right-add-button"
                      :class="scope.row.status !== 30 ? 'disabled-text' : ''"
                      @click="scope.row.status === 30 && edit(scope.row)"
                      >【修改】</span
                    >
                    <span
                      class="right-add-button"
                      @click="lookOpinion(scope.row)"
                      >【查看审核意见】</span
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!-- 主列表分页 -->
              <div class="pagination-box">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalSize"
                >
                </el-pagination>
              </div>
            </div>

            <el-dialog title="审核意见详情" :visible.sync="opinionDialog" width="600px">
              <div v-if="opinionList.length === 0" style="text-align:center;padding:50px 0;color:#999;">
                <i class="el-icon-tickets" style="font-size:36px;color:#dcdfe6;"></i>
                <p style="margin-top:12px;font-size:15px;">当前无审核意见</p>
              </div>
              <div v-else>
                <div v-for="(item, index) in opinionList" :key="index" style="border:1px solid #ebeef5;border-radius:8px;padding:18px;margin-bottom:14px;background:#fefefe;">
                  <div style="font-size:14px;color:#606266;margin-bottom:10px;">
                    <i class="el-icon-time"></i> 审核时间：{{ item.auditTime }}
                  </div>
                  <div style="line-height:1.7;font-size:14px;color:#303133;white-space:pre-wrap;">
                    {{ item.opinion }}
                  </div>
                </div>
              </div>

              <div slot="footer" class="dialog-footer">
                <el-button @click="opinionDialog = false">关闭</el-button>
              </div>
            </el-dialog>
        </div>  
    </div>
</template>

<script>
  import '@/assets/css/index.css';
  import $ from 'jquery'; 
  
  export default {
    data() {
      return {
        formInline: {
          user: '',
          region: ''
        },
        collaboratorsTable:[],
        addCollaboratorsDialog:false,
        opinionDialog:false,
        opinionList:[],
        addCollaboratorsForm:{},
        fileList: [],
        myShenBaoData:[],
        tableLoading: false,
        multipleSelectionTable: [],
        currentPage: 1,
        pageSize: 10,
        totalSize: 50,
        userData:"9apV+UOuIx0F9WAh+5G4yq/8Cvx8XB3sf0OJd9i/VwuzPNWgosMLDs1lWaqyZwKiQa73exqQ5ELXl3QJmSYz/Q==",
        // ajaxUrl: "https://zg.zgbk.com/zxzg",

      }
    },
    mounted() {
        var that = this;
        $.ajax({
            url: 'https://test.zgbk.com/ecph/dk/encode/data',
            type: "POST",
            error: function (xhr) {
            if (xhr.status == 401) {
                window.location.reload();
            }
            },
            success: function (data) {
                if(data.code == 200) {
                    that.userData = data.data;
                }else{
                    that.$message({
                        message: data.msg,
                        duration: 20000,
                        showClose: true,
                        type: "error",
                        offset: 100,
                    });
                }
            },
        });
        this.searchParam();
    },
    methods: {
        
        // 搜索
        onSearch() {
          this.searchParam();
        },
        // 加载数据
        searchParam() {
          let that = this;
          let params = {};
        //   let params = Object.assign({}, this.searchFileForm);
          params.size = this.pageSize;
          params.page = this.currentPage;
          // params.data = this.userData;
          params.data = this.userData;
          params.actId = 2;

        //   that.tableLoading = true;
          $.ajax({
            type: "POST",
            dataType: "json",
            url: "/zxzg/api/vh/free/act/submitInfo/list",
            data: params,
            // contentType: "application/json;charset=utf-8",
            success: function (response) {
              if (response.code == 200) {
                that.optionData = response.obj.list;
                if (response.obj.list && response.obj.list.length == 0) {
                  that.dataText = "暂无数据";
                }
                // that.tableLoading = false;
                that.totalSize = response.obj.total;
                that.myShenBaoData = response.obj.list;
                that.currentPage = response.obj.pageNum;
              } else {
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
            error: function (data) {
              console.log(data);
            },
          });
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.searchParam();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.searchParam();
        },
        
        // 选择表格某一行
        handleTableSelectionChange(val) {
        this.multipleSelectionTable = val;
        },
        preview(row) {
          window.location.href = "/zxzg/api/vh/pdf/preview?mergeId="+row.mergeId;
        },
        // 编辑征稿
        edit(row) {
          window.open('/?sid=' + encodeURIComponent(row.sid), '_blank')
        },
        lookOpinion(row) {
          this.opinionList = row.opinionList;
          this.opinionDialog = true;
        }
    }
  }
</script>

<style>
button.el-button--text {
    background-color: transparent;
    border-color: transparent;
    color: #4c5d65;
    font-size: 14px;
    font-weight: 700;
    padding-left: 8px;
    padding-right: 8px;
    border-radius: 5px;
}
.right-add-button{
    display: block;
    color:rgba(205, 32, 34, 0.8);
    cursor: pointer;
}
/* 置灰样式 */
.disabled-text{
    color:#c0c4cc !important;
    cursor:not-allowed !important;
}
</style>